export default {
  Community: {
    editingCase: {
      titleTextareaPlaceholder: "Décrivez le cas ou posez une question",
      sybmolCount:
        "Le nombre de caractères doit être compris entre {min} et {max}",
      wordsCount: "Le nombre de mots doit être compris entre {min} et {max}",
      mobiledocPlaceholder:
        "Dites-nous en plus sur les données d'examen du patient",
      mobiledocLabel: "Données d'examen",
      tags: "Mots Clés",
      editCase: "Modifier le cas",
      anamnesisPlaceholder:
        "Dites-nous en plus sur les antécédents médicaux du patient",
      treatmentPlaceholder: "Dites-nous en plus sur le traitement du patient",
      caseNotesPlaceholder: "Dites-nous en plus sur l'affaire",
      questionNotesPlaceholder: "Dites-nous en plus sur la question",
      addImage: "Joindre une image",
      anamnesis: "Anamnèse",
      treatment: "Traitement",
      notes: "Ajout",
    },
    uploader: {
      case: {
        title: "Ajouter un cas",
        description: "Partagez des cas intéressants de votre pratique",
      },
      question: {
        title: "Poser une question",
        description:
          'Les utilisateurs répondront plus rapidement si vous sélectionnez "Question".',
      },
    },
    title: "Communauté",
    description:
      "Partage de connaissances entre médecins sur des cas cliniques",
    all_cases: "Tous les cas",
    my_cases: "Mes cas",
    case: {
      shareLink: {
        1: "Découvrez le boîtier",
        2: "sur «Third Opinion» Plateforme:",
      },
    },
    noCasesLang: {
      1: "Il n'y a pas encore de cas publiés dans cette langue",
      2: "Soyez le premier à partager une étude DICOM et obtenir l'avis de vos collègues !",
    },
    filter: {
      status: {
        placeholder: "Trier les cas",
        values: {
          popular: "Populaire en premier",
          actual: "Récent en premier",
        },
        options: {
          base: "Afficher en premier",
          popular: "Populaire",
          actual: "Récent",
        },
      },
      modality: {
        placeholder: "Modalité",
      },
      bodypart: {
        placeholder: "Zone d'étude",
      },
      sex: {
        placeholder: "Sexe",
        values: {
          M: "Homme",
          F: "Femme",
        },
      },
    },
  },
  h1_community: "Communauté de médecins",
};
